import { Stepper as AdsStepper, StepperItem as AdsStepperItem } from '@ads/components-react';

export interface StepperItemConfig {
  readonly title: string;
  readonly description?: string;
}

export interface StepperProps {
  readonly steps: readonly StepperItemConfig[];
  readonly currentStep: number;
  readonly onStepClick?: (index: number) => void;
  readonly className?: string;
}

export function Stepper({ steps, currentStep, onStepClick, className }: StepperProps) {
  return (
    <AdsStepper activeStep={currentStep} className={className}>
      {steps.map((step, i) => {
        const status = i < currentStep ? 'completed' : i === currentStep ? 'current' : 'incomplete';
        const position = i === 0 ? 'start' : i === steps.length - 1 ? 'end' : 'middle';
        const clickable = onStepClick !== undefined && i <= currentStep;
        return (
          <AdsStepperItem
            key={step.title}
            title={step.title}
            {...(step.description !== undefined ? { description: step.description } : {})}
            status={status}
            position={position}
            {...(clickable ? { onClick: () => onStepClick(i), style: { cursor: 'pointer' } } : {})}
          />
        );
      })}
    </AdsStepper>
  );
}
